import React, { Component } from 'react';
import { canCatalogue, can } from '../permissions/access';
import { withRouter } from 'react-router-dom';
import TopHeader from '../template/TopHeader';
import MobileSubmenu from '../shared/MobileSubmenu';
import { connect } from "react-redux";
import axios from 'axios';
import config from '../../config/API';

class ServiceMobileView extends Component {

    constructor(props) {
        super(props);

        const cachedSettings = localStorage.getItem('receptionModeSettings');
        const initialSettings = cachedSettings ? JSON.parse(cachedSettings) : {
            enabled: false,
            hiddenAreas: {
                diary: false, checkout: false, clients: false, transactions: false,
                catalogue: false, services: false, products: false, stocktake: false,
                staff: false, settings: false, marketing: false, giftcards: false
            }
        };

        this.state = {
            receptionModeSettings: initialSettings,
            isInitialized: !!cachedSettings
        };
    }

    componentDidMount() {
        const cachedSettings = localStorage.getItem('receptionModeSettings');
        if (!cachedSettings) {
            this.checkReceptionModeSettings();
        }
        window.addEventListener('receptionModeSettingsChanged', this.handleReceptionModeSettingsChanged);
    }

    componentWillUnmount() {
        window.removeEventListener('receptionModeSettingsChanged', this.handleReceptionModeSettingsChanged);
    }

    handleReceptionModeSettingsChanged = (event) => {
        if (event.detail) {
            const { enabled, hiddenAreas } = event.detail;
            if (enabled !== undefined) {
                this.setState({
                    receptionModeSettings: {
                        enabled,
                        hiddenAreas: hiddenAreas || this.state.receptionModeSettings.hiddenAreas
                    }
                });
            }
        }
    };

    checkReceptionModeSettings = () => {
        const { user } = this.props;
        if (!user || !user.userInfo || !user.userInfo.hairdresser) {
            this.setState({ isInitialized: true });
            return;
        }

        const hairdresserId = user.userInfo.hairdresser._id;
        let accessToken = localStorage.getItem('accessToken');

        axios.get(`${config.RECEPTION_MODE_SETTINGS}?hairdresserId=${hairdresserId}`, {
            headers: {
                'Content-Type': 'application/json',
                'authorization': "Basic YmV1YXBwOmJldWFwcA==",
                'accessToken': accessToken
            }
        })
        .then(response => {
            if (response.data.statusCode === 1) {
                const { enabled, hiddenAreas } = response.data.responseData;
                const newSettings = {
                    enabled,
                    hiddenAreas: hiddenAreas || this.state.receptionModeSettings.hiddenAreas
                };
                this.setState({ receptionModeSettings: newSettings, isInitialized: true });
                if (enabled) {
                    localStorage.setItem('receptionModeSettings', JSON.stringify(newSettings));
                }
            } else {
                this.setState({ isInitialized: true });
            }
        })
        .catch(error => {
            console.error('Error fetching reception mode settings:', error);
            this.setState({ isInitialized: true });
        });
    };

    handleNavClick = (url) => {
        this.props.history.push(url);
    };

    isSalonOwner = () => {
        const { user } = this.props;
        return user && user.userInfo && user.userInfo.hairdresser && user.userInfo.hairdresser.isSalonOwner === 1;
    }

    render() {
        const { receptionModeSettings } = this.state;
        const rm = receptionModeSettings;

        const navItems = [];

        if (!rm.enabled || !rm.hiddenAreas.services) {
            navItems.push({
                id: 'services',
                title: 'Services',
                description: 'Manage your service list',
                url: '/new-services',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" /></svg>
            });
        }

        if (canCatalogue(this.isSalonOwner()) && (!rm.enabled || !rm.hiddenAreas.products)) {
            navItems.push({
                id: 'products',
                title: 'Products',
                description: 'Manage products sold by business',
                url: '/product',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" /></svg>
            });
        }

        if (canCatalogue(this.isSalonOwner()) && (!rm.enabled || !rm.hiddenAreas.giftcards)) {
            navItems.push({
                id: 'vouchers',
                title: 'Vouchers',
                description: 'Set up voucher options',
                url: '/voucher-v2',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="6" width="22" height="12" rx="2" /><line x1="1" y1="12" x2="23" y2="12" /><path d="M12 6v12" /></svg>
            });
        }

        if (canCatalogue(this.isSalonOwner()) && (!rm.enabled || !rm.hiddenAreas.stocktake)) {
            navItems.push({
                id: 'stocktake',
                title: 'Stock Take',
                description: 'Manage physical stock counts',
                url: '/stocktake',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 5H2v7l6.29 6.29c.94.94 2.48.94 3.42 0l4.58-4.58c.94-.94.94-2.48 0-3.42L9 5z" /><path d="M6 9.01V9" /><path d="M15 5l6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19" /></svg>
            });
        }

        if ((this.isSalonOwner() || can('settings')) && (!rm.enabled || !rm.hiddenAreas.resources)) {
            navItems.push({
                id: 'resources',
                title: 'Resources',
                description: 'Rooms, basins, chairs and machines',
                url: '/resources',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18" /><path d="M5 21V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v14" /><path d="M14 21v-6a2 2 0 0 0-4 0v6" /></svg>
            });
        }

        if (canCatalogue(this.isSalonOwner()) && (!rm.enabled || !rm.hiddenAreas.forms)) {
            navItems.push({
                id: 'forms',
                title: 'Forms',
                description: 'Manage client forms',
                url: '/forms',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" /></svg>
            });
        }

        return (
            <div className="h_n">
                <div className="body_container cm_bg_white">
                    <TopHeader title="Catalogue" headerButtonStatus={true} {...this.props} />
                    <MobileSubmenu items={navItems} onNavigate={this.handleNavClick} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { ...state };
}

export default withRouter(connect(mapStateToProps)(ServiceMobileView));
